import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvemanpower',
  templateUrl: './approvemanpower.component.html',
  styleUrls: ['./approvemanpower.component.css']
})
export class ApprovemanpowerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
